<template>
	<ul :class="listClass">
		<AppDescriptionItem
			v-for="(item, index) of messageList"
			:key="index"
			:message="item"
		/>
	</ul>
</template>

<script>
import AppDescriptionItem from './AppDescriptionItem';

export default {
	components: {
		AppDescriptionItem,
	},
	props: {
		useBackgroundColor: {
			type: Boolean,
			default: false,
		},
		messageList: {
			type: Array,
			default: () => [],
			validator(array) {
				return array.length > 0;
			},
		},
	},
	computed: {
		listClass() {
			return [
				'app-description-list',
				{ 'app-description-list--color-bg': this.useBackgroundColor },
			];
		},
	},
};
</script>
